import React, { CSSProperties } from 'react';

import './ThemeCheckBox.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  spanStyle?: CSSProperties;
  label?: string;
  checked: boolean;
  round?: boolean;
  outline?: boolean;
  color?: 'orange' | 'rose' | 'emerald';
  width?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
  name?: string;
}

const ThemeCheckBox: React.FC<Props> = ({
  onChange,
  style,
  spanStyle,
  label,
  checked = false,
  color = 'emerald',
  round,
  outline,
  width,
  name,
}) => {
  return (
    <div className="theme-checkbox" style={{ width }}>
      <label className={`theme-checkbox-container ${color}`}>
        {label && <p>{label}</p>}
        <input
          onChange={onChange}
          style={{ ...style }}
          type="checkbox"
          checked={checked}
          name={name}
        />
        <span
          className={`${round ? 'round' : ''} ${outline ? 'outline' : ''} checkmark`}
          style={spanStyle}
        />
      </label>
    </div>
  );
};

export default ThemeCheckBox;
